// extracted by mini-css-extract-plugin
module.exports = {"box":"box--sX8sb","list":"list--7DBCT"};